import { Component, Input, OnInit } from '@angular/core';
import { RoleService } from 'services/role.service';
import { SharedService } from 'services/shared.service';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { SearchEAndO } from 'models/eando/search-eando.model';
import { EAndO } from 'models/eando/eando.model';
import { EandoService } from 'api-services/eando.service';
import { eandOType } from 'shared/constant';

@Component({
  selector: 'app-contact-error-omissions-bonds',
  templateUrl: './contact-error-omissions-bonds.component.html',
  styleUrls: ['./contact-error-omissions-bonds.component.css']
})
export class ContactErrorOmissionsBondsComponent implements OnInit {

  @Input() userId: number;
  @Input() branchId: number;
  @Input() branchName : string;
  @Input() tenantId: number;
  @Input() isDeleted: boolean;
  darkScrollbarOptions: MCustomScrollbar.CustomScrollbarOptions = { axis: 'y', theme: 'light', setHeight: 254 };
  activeTab = "#activeEandO";

  searchEAndO: SearchEAndO = {
    pageNumber: 1,
    pageSize: Number(environment.pageSize)
  } as SearchEAndO;
  eandoList: EAndO[] = [] as EAndO[];
  overallCount: number = 0;
  activeList: boolean = false;

  showLoader: boolean = false;
  isIndividualUser = false;
  sortDir = 0;
  currentPage = false;

  eandOType = eandOType;
  userProfile = localStorage.hasOwnProperty('userProfile') ? JSON.parse(localStorage['userProfile']) : null;
  eandOTypeId: number = null;
  selectedRecordId: number = null;


  constructor(private sharedService: SharedService, private roleService: RoleService,
    private router: Router, private eandoService: EandoService
  ) {
    this.router.events.subscribe((val) => {
      this.currentPage = this.router.url.includes('downlining');
    });
  }

  ngOnInit(): void {
    this.showLoader = true;
    this.isIndividualUser = this.roleService.isIndividualUser;
    this.getEandO();
  }

  getSelectedTab(event) {
    this.showLoader = true;
    this.activeList = false;
    this.searchEAndO = {
      pageNumber: 1,
      pageSize: Number(environment.pageSize)
    };
    this.activeTab = event.srcElement.hash != undefined ? event.srcElement.hash : this.activeTab;
    
    this.getEandO();
  }

  getEandO() {

    this.searchEAndO.isArchived = this.activeTab == '#activeEandO' ? false : true;
    this.searchEAndO.userId = this.userId;
    this.searchEAndO.tenantId = this.tenantId;
    this.searchEAndO.isFromContactDashboard = true;
    this.eandoService.getEAndOByTenantId(this.searchEAndO, false).subscribe(response => {
      if (response) {
        this.eandoList = response.map(el => ({
          ...el,
          createdDate: this.sharedService.convertUTCTimeToLocalTime(el.createdDate),
          updatedDate: this.sharedService.convertUTCTimeToLocalTime(el.updatedDate)
        }));
        this.showLoader = false;
        this.activeList = true;
        this.overallCount = this.eandoList[0]?.overallCount ? this.eandoList[0]?.overallCount : this.eandoList.length;
        // this.createRange();
      }
    })
  }

onSortClick(event, colName) {
    let target = event.currentTarget,
      classList = target.classList;

    if (classList.contains('sorting-icon-asc')) {
      classList.remove('sorting-icon-asc');
      classList.add('sorting-icon-des');
      this.sortDir = 1;
    } else {
      classList.add('sorting-icon-asc');
      classList.remove('sorting-icon-des');
      this.sortDir = 0;
    }
    this.searchEAndO.sortBy = colName;
    this.searchEAndO.sortOrder = this.sortDir;
    this.getEandO();
  }

  loadURL() {
    var isFirm = false;
    if (this.branchId != undefined || this.branchId != null || this.branchId > 0)
    {
      const contactObj = {
        branchId: this.branchId,
        isTypeFirm : true,
        branchName : this.branchName
      }
      this.sharedService.sharedObj(contactObj);

      isFirm = true;
    }

    this.router.navigate(['/errors-omissions/user'], { state: { isProducer: true, isFirm: isFirm, isArchived: this.searchEAndO.isArchived, isFromContactDashboard : true} });
  }


  redirectToEandO() {
    sessionStorage.setItem('scrollToEandO', 'true');
    if (this.branchId != undefined || this.branchId != null || this.branchId > 0)
    {
      const contactObj = {
            branchId: this.branchId,
            eandOTypeId: this.eandOTypeId,
            isTypeFirm : true,
            branchName : this.branchName
          }

          this.sharedService.sharedObj(contactObj);
          if(this.eandOTypeId == eandOType.eAndO){
            this.router.navigate(['errors-omissions/user/add-eando']);
          }else if(this.eandOTypeId == eandOType.bond){
            this.router.navigate(['errors-omissions/user/add-bond']);
    }
    }
    else{
    const contactObj = {
      userId: this.userId,
      firstName: this.userProfile.firstName,
      lastName: this.userProfile.lastName,
      npNumber: this.userProfile.npn,
      branchId: this.userProfile.branchId,
      email: this.userProfile.email,
      eandOTypeId: this.eandOTypeId
    }
        this.sharedService.sharedObj(contactObj);
          if(this.eandOTypeId == eandOType.eAndO){
          this.router.navigate(['errors-omissions/user/add-eando']);
        }else if(this.eandOTypeId == eandOType.bond){
          this.router.navigate(['errors-omissions/user/add-bond']);
        }
    }

  }
}
